import { inject } from "mobx-react";
import React from "react";
import type { Store } from "../../../client/stores";
import { Modal } from "../ui";
import "./AuthModal.component.scss";

interface AuthModalProps {
    store?: Store;
}

interface AuthModalState {
    open: boolean;
}

@inject("store")
export class AuthModal extends React.Component<AuthModalProps, AuthModalState> {
    mounted = false;
    auth = React.createRef<HTMLDivElement>();

    constructor(props: AuthModalProps) {
        super(props);

        this.state = {
            open: false,
        };
    }

    componentDidMount() {
        this.mounted = true;
        this.props?.store?.onAuthAction.subscribe(event => {
            if (this.mounted) {
                this.setState({
                    open: event.action === "pending",
                });
            }
        });
        this.insertAuthContainer();
    }

    insertAuthContainer() {
        const authContainer = document.querySelector("#ihr-auth-container");
        const authMoved = document.querySelector(".auth-modal .auth-container");
        if (this.auth.current && authContainer && !authMoved) {
            authContainer.classList.add("auth-container");
            this.auth.current.replaceWith(authContainer);
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    handleClose = () => {
        if (this.mounted) {
            this.setState({
                open: false,
            });
        }
    };

    render() {
        return (
            <Modal open={this.state.open} callback={this.handleClose} addClass="auth-modal">
                <div ref={this.auth} />
            </Modal>
        );
    }
}

export default AuthModal;
